var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.connectionReady)?_c('div',{staticClass:"container d-flex justify-content-center",staticStyle:{"min-height":"60px"}},[_c('b-spinner',{attrs:{"large":"","variant":"primary"}})],1):_c('WinbackView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }